// === App.jsx ===
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileMenu from "./components/MobileMenu";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startConnection } from "./services/signalRClient";

const App = () => {
  const [theme, setTheme] = useState(() =>
    localStorage.getItem("theme") ||
    (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
  );

  const [activeNav, setActiveNav] = useState("hero");
  const [menuOpen, setMenuOpen] = useState(() => localStorage.getItem("menuOpen") === "true");

  useEffect(() => {
    localStorage.setItem("menuOpen", menuOpen);
  }, [menuOpen]);

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-fade-in-up");
          const id = entry.target.getAttribute("id");
          if (id) setActiveNav(id);
        }
      });
    }, { threshold: 0.3 });

    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  useEffect(() => {
    startConnection();
  }, []);

  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"));
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setActiveNav(id);
    setMenuOpen(false);
  };

  return (
    <Router>
      <>
        <ToastContainer
          className="!fixed top-22 left-1/2 -translate-x-1/2 !z-[100]"
          position="top-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable={false}
          transition={Slide}
        />

        <div className={`min-h-screen font-sans transition-colors duration-500 ${theme === "dark" ? "bg-[#0d1117] text-white" : "bg-white text-black"}`}>
          <style>{`
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(40px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .animate-fade-in-up {
              animation: fadeInUp 0.8s ease-out both;
            }
          `}</style>

          <Header scrollTo={scrollTo} activeNav={activeNav} theme={theme} toggleTheme={toggleTheme} setMenuOpen={setMenuOpen} />
          {menuOpen && <MobileMenu scrollTo={scrollTo} setMenuOpen={setMenuOpen} />}
          <AppRoutes theme={theme} scrollTo={scrollTo} />
          <Footer />
        </div>
      </>
    </Router>
  );
};

export default App;